export const Roles = {
  admin: 'Admin',
  kioskAdmin: 'Kiosk Admin',
};

export const RolesKey = 'https://goodingco.com/roles';
